import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ViewSiteButton from './ViewSiteButton';
import {
    getPropertyTitle as getPropertyTitleAction,
    getThemeTitle as getThemeTitleAction,
    getConfigTitle as getConfigTitleAction
} from '../../actions/global';

class DashboardPreview extends Component {
    render() {
        const { getPropertyTitle, getThemeTitle, getConfigTitle, isThemeSbem } = this.props;
        const property = getPropertyTitle();
        const theme = getThemeTitle();
        const config = getConfigTitle();

        return (
            <div className="preview-site-holder">
                <div className="info-container">
                    <div className="parameters-info-container">
                        <h1>View: {property}</h1>
                        <div>{isThemeSbem ? 'In-context theme: ' : 'Theme: '}{theme}</div>
                        <div>Config: {config}</div>
                    </div>
                    <div className="preview-button-container-info">
                        <ViewSiteButton size="md" />
                    </div>
                </div>
                <div className="banner-container">
                    <span className="icon-wrapper">
                        <i className="spark-icon--fill spark-icon-note spark-icon--md" />
                    </span>
                    <span className="spark-bold">View your saved changes in the booking engine. </span>
                    <span>To see your saved changes anytime, click "View Site" in the header.</span>
                </div>
            </div>
        );
    }
}

DashboardPreview.propTypes = {
    chain: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    configCode: PropTypes.string.isRequired,
    hotel: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return {
        chain: state.app.selected.chain.Id,
        code: state.app.selected.code,
        configCode: state.app.data.configuration.configuration.configCode,
        hotel: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        isThemeSbem: state.app.selected.isThemeSbem
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getPropertyTitle: () => {
            return dispatch(getPropertyTitleAction());
        },
        getThemeTitle: () => {
            return dispatch(getThemeTitleAction());
        },
        getConfigTitle: () => {
            return dispatch(getConfigTitleAction());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPreview);



// WEBPACK FOOTER //
// ./src/components/common/DashboardPreview.js